<template>
  <div  style="background-color: #f8f8f8;min-height: 100%;padding:10px;">
    <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
      <div style="text-align:left">
        <a @click="back">返回分组列表</a>
        <cite>|</cite>
        <a @click="modal1=true">导入数据</a>
        <cite>|</cite>
        <a @click="remove">删除所有数据</a>
        <cite>|</cite>
        <a @click="load">刷新</a>
      </div>
    </Card>

    <Row style="margin-top:10px">
      <Col span="24">
        <Card :bordered="false"  dis-hover>
          <p slot="title">发件箱列表（{{count}}）</p>
          <el-table
            :data="list"
            size="small"
            style="width: 100%">
            <el-table-column prop="id" width="80" label="编号"></el-table-column>
            <el-table-column prop="name" label="标题" ></el-table-column>
          </el-table>
        </Card>
      </Col>
    </Row>

    <Card  :bordered="false" dis-hover style="text-align: center">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitchange"  show-elevator @on-change="change"  show-elevator  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      width="600"
      title="批量增加发件箱"
      @on-ok="save"
      @on-cancel="cancel">
      <Input type="textarea" v-model="form.boxs" :autosize="{minRows: 12,maxRows: 12}" placeholder="格式：一行一个"></Input>
    </Modal>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        list:[],
        page:1,
        limit:10,
        count:0,
        modal1:false,
        form:{
          boxs:'',
          gpid:0,
        },
        modal2:false,//分配发件箱
        form2:{
          groupstart:0,
          groupend:0,
          outboxstart:0,
          outboxend:0,
        }
      }
    },
    methods:{
      back(){
        this.$router.go(-1)
      },
      limitchange(limit){
        this.limit = limit;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      load(){
        let that = this;
        this.$Spin.show();
        let params = [];
        params.push('gpid@=@'+this.form.gpid);
        this.$axios.get('/api/cp/findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.$Spin.hide();
        });
      },
      save(){
        let that = this;
        this.$axios({url:'/api/cp/save',method:'post',data:this.$qs.stringify(this.form)}).then(function(rs){
          that.toast(rs.data);
        });
      },
      save2(){//保存发件箱分配
        for(let attr in this.form2){
          if(this.form2[attr]<=0){
            this.$Message.warning('请填写完整');
            return;
          }
        }
        let that = this;
        this.$Spin.show();
        this.$axios({url:'/api/outbox/allot',method:'post',data:this.$qs.stringify(this.form2)}).then(function(rs){
          that.toast(rs.data);
          that.$Spin.hide();
        });

      },
      remove(){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除所有发件箱吗（不可恢复）',
          onOk: () => {
            let that = this;
            this.$axios.get('/api/cp/removeAll?gpid='+this.form.gpid).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      allot(){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要平均分配所有发件箱吗',
          onOk: () => {
            let that = this;
            this.$axios.get('/api/outbox/allot').then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      outFile(state){
        window.location = '/api/client/out?state='+state
      },
      toast(data){
        if(data.success){
          this.$Message.success(data.msg);
          this.load();
        }else{
          this.$Message.error(data.msg+"，请确保邮箱地址不重复");
        }
      }

    },
    created(){
      this.form.gpid = this.$router.history.current.query.id;
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cp/Cp.vue